import { combineReducers } from 'redux'
import estimatesReducer from './estimatesReducer'
import userReducer from './userReducer'

export default combineReducers({
  estimate: estimatesReducer,
  user: userReducer
})



// WEBPACK FOOTER //
// ./src/reducers/index.js